module.exports = __webpack_public_path__ + "static/media/hydronomad-2.890f6aa3.jpg";